import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthModalState {
	open: boolean;
	mode?: 'auth' | 'setup';
}

const initialState: AuthModalState = { open: false, mode: 'auth' };

export const authModalSlice = createSlice({
	name: 'authModal',
	initialState,
	reducers: {
		openAuthModal(state) {
			state.open = true;
			state.mode = 'auth';
		},
		openAuthModalWithMode(state, action: PayloadAction<'auth' | 'setup'>) {
			state.open = true;
			state.mode = action.payload;
		},
		closeAuthModal(state) {
			state.open = false;
			state.mode = 'auth';
		},
	},
});

export const { openAuthModal, openAuthModalWithMode, closeAuthModal } = authModalSlice.actions;
